import { render, staticRenderFns } from "./AccessesPanel.vue?vue&type=template&id=c2840ad8&scoped=true"
import script from "./AccessesPanel.vue?vue&type=script&lang=js"
export * from "./AccessesPanel.vue?vue&type=script&lang=js"
import style0 from "./AccessesPanel.vue?vue&type=style&index=0&id=c2840ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2840ad8",
  null
  
)

export default component.exports